import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export type GlobalConfig = {
  source?: { url: string };
  meetingUi?: { url: string };
  schoolUi?: { url: string };
  academyUi?: { url: string };
  pendoIo?: { apiKey: string };
};

const ConfigContext = createContext<GlobalConfig>({});

export const useConfig = () => useContext(ConfigContext);

const ContextConfigProvider = ({ children, value }) => {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

ContextConfigProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.shape({}),
};

ContextConfigProvider.defaultProps = {
  children: {},
  value: {},
};

export default ContextConfigProvider;
